import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { RolsExternal } from 'src/app/core/entities/rolsexternal.model';
import { MatDialog } from '@angular/material/dialog';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { EditDialogsRolexternalComponent } from './dialogs-rolexternal/edit-dialogs-rolexternal/edit-dialogs-rolexternal.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-rolexternal',
  templateUrl: './rolexternal.component.html',
  styleUrls: ['./rolexternal.component.scss']
})
export class RolexternalComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  rolsExternal: RolsExternal = new RolsExternal();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.mensajeError = false;
    this.getAllRolsExternal();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla rolexternal
  */
  private getAllRolsExternal(): void {
    this.loading = true;
    this.internalHomeService.allRolsExternal().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un rol external
  * @param parametro Opcional. Parametro vacio.
  */
  public createRolsExternal(rolsExternal?: RolsExternal) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    rolsExternal = this.rolsExternal;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsRolexternalComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { rolsExternal, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllRolsExternal();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un rol external
  * @param parametro Opcional. Rol external a editar.
  */
  public editRolsExternal(rolsExternal?: RolsExternal) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsRolexternalComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { rolsExternal, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllRolsExternal();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un rol external
  * @param parametro Rol external a eliminar
  */
  public removeRolsExternal(rolsExternal?: RolsExternal) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_rolexternal') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeRolsExternal(rolsExternal).subscribe(res => {
          console.log(res);
          this.getAllRolsExternal();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
